import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { useAdsType } from '@wix/da-ads/pkg/useAdsType';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
export function useShowMobileAd(deviation) {
    const deviationType = getDeviationType(deviation);
    const { adsEnabled } = useContext(SessionContext);
    const isMobile = useContext(MobileContext);
    const adsEnabledDeviation = [
        DeviationTypes.IMAGE
    ].includes(deviationType);
    const adsType = useAdsType();
    const ads_novid_mobile = useFlag('ads_novid_mobile');
    return {
        showVideoBtfAd: isMobile && adsEnabled && adsEnabledDeviation && adsType === 'anon' && !ads_novid_mobile,
        showBtfAd: isMobile && adsEnabled && adsEnabledDeviation && adsType === 'anon' && ads_novid_mobile,
        showAtfAd: isMobile && adsEnabled && adsEnabledDeviation && adsType === 'anon',
        showAdhesionAd: isMobile && adsEnabled
    };
}
